import * as React from 'react';
import styled from 'styled-components';
import { Input } from '../../../components/blocks';

// SPAM-honeypot
// https://help.salesforce.com/s/articleView?id=sf.pardot_forms_add_honeypot.htm&type=5

const Label = styled.label`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.fontColors.lightgrey};
`;

const Root = styled.div`
  position: absolute;
  top: -9999px;
  left: -9999px;
`;

export const HoneyPod: React.FC = () => {
  return (
    <Root>
      <Label htmlFor="pardot_extra_field">Comments</Label>
      <Input type="text" id="pardot_extra_field" name="pardot_extra_field" />
    </Root>
  );
};
